<template>
  <b-row>
    <!-- left -->
    <b-col sm="3">
      <b-list-group>
        <b-list-group-item
          ><i class="fa fa-star"></i> <b>Overview</b></b-list-group-item
        >
        <b-list-group-item><a href="">Information</a></b-list-group-item>
      </b-list-group>
      <br />
      <b-list-group>
        <b-list-group-item
          ><i class="fa fa-cogs"></i> <b>Actions</b></b-list-group-item
        >
        <b-list-group-item v-for="(row, id) in actions" :key="id">
          <a :href="row.aksi">{{ row.name }}</a>
        </b-list-group-item>
      </b-list-group>
    </b-col>

    <!-- right -->
    <b-col sm="9">
      <RWCard>
        <template v-slot:title>
          <h3 class="kt-portlet__head-title">Manage Product</h3>
        </template>
        <template v-slot:body>
          <h4>FlockMail Pro - rumahweb.com</h4>
          <div
            class="well"
            style="
              background-image: url('https://cdn01.rumahweb.com/whmcs/img/rwpanel-banner.jpg');
              background-color: #33aae2;
              background-repeat: no-repeat;
              background-position: 50% 0;
            "
          >
            <p style="margin-top: 260px" class="text-center"></p>
            &nbsp;
            <div class="text-center">
              <a href="" class="btn btn-primary" target="_blank"
                ><strong>Login to Flock Mail</strong></a
              >
            </div>
            <br />
          </div>

          <br />
          <b-row>
            <b-col sm="6">
              <b-card>
                <template v-slot:header
                  ><i class="fa fa-cube"></i> Informasi Account</template
                >
                <table class="table table-sm">
                  <tr v-for="(acc, id) in informasi_account" :key="id">
                    <td>
                      <b>{{ acc.name }}</b>
                    </td>
                    <td>:</td>
                    <td>
                      <b>{{ acc.value }}</b>
                    </td>
                  </tr>
                </table>
              </b-card>
            </b-col>
            <b-col sm="6"> </b-col>
          </b-row>
        </template>
      </RWCard>
    </b-col>
  </b-row>
</template>

<script>
import RWCard from "@/views/partials/content/Portlet.vue";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
export default {
  components: {
    RWCard
  },
  data() {
    return {
      actions: [
        {
          name: "Request Cancellation",
          aksi: ""
        }
      ],
      informasi_account: [
        { name: "Domain", value: "Rumahweb.com" },
        { name: "Billing Cycle", value: "Monthly" },
        { name: "Registrasi Date", value: "17-08-1945" },
        { name: "Due Date", value: "17-08-1945" },
        { name: "Account Email", value: 3 }
      ]
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Products & Services", route: "product/all" },
      { title: "Detail Flockmail" }
    ]);
  }
};
</script>
